(() => {

    class ProofAccordion {

        constructor(root) {

            this.root = root;

            this.items = [
                ...root.querySelectorAll('.proof-item')
            ];

            if (!this.items.length) return;

            this.bind();

            this.items.forEach(item => {

                if (item.classList.contains('is-open')) {

                    this.open(item, false);

                }

            });

        }

        bind() {

            this.items.forEach(item => {

                const button = item.querySelector('.proof-item__header');

                button.addEventListener('click', () => {

                    if (item.classList.contains('is-open')) return;

                    this.items.forEach(other => {

                        if (other !== item) {

                            this.close(other);

                        }

                    });

                    this.open(item);

                });

            });

            window.addEventListener('resize', () => {

                this.items.forEach(item => {

                    if (item.classList.contains('is-open')) {

                        this.setHeight(item);

                    }

                });

            });

        }

        updateRadius() {

            this.items.forEach(item => {

                item.classList.remove(
                    'has-radius-top',
                    'has-radius-bottom',
                    'has-radius-both'
                );

            });

            const openIndex = this.items.findIndex(item =>
                item.classList.contains('is-open')
            );

            this.items.forEach((item, index) => {

                if (index === openIndex) {
                    return;
                }

                if (index === 0) {

                    if (openIndex === 0) {

                    } else if (openIndex === 1) {

                        item.classList.add('has-radius-both');

                    } else {

                        item.classList.add('has-radius-top');

                    }

                }

                if (index === this.items.length - 1) {

                    if (openIndex === this.items.length - 1) {

                    } else if (openIndex === this.items.length - 2) {

                        item.classList.add('has-radius-both');

                    } else {

                        item.classList.add('has-radius-bottom');

                    }

                }

                if (index === openIndex - 1) {

                    item.classList.add('has-radius-bottom');

                }

                if (index === openIndex + 1) {

                    item.classList.add('has-radius-top');

                }

            });

        }

        setHeight(item) {

            const content = item.querySelector('.proof-item__content');
            const inner = item.querySelector('.proof-item__inner');

            content.style.setProperty(
                '--content-height',
                `${inner.scrollHeight}px`
            );

        }

        open(item, animate = true) {

            const content = item.querySelector('.proof-item__content');

            this.setHeight(item);

            if (!animate) {

                content.style.transition = 'none';

                requestAnimationFrame(() => {

                    content.style.transition = '';

                });

            }

            item.classList.add('is-open');

            this.updateRadius();

        }

        close(item) {

            item.classList.remove('is-open');

        }

    }

    document
        .querySelectorAll('[data-proof-accordion]')
        .forEach(section => {

            new ProofAccordion(section);

        });

})();